import { AccountsApiService } from '@accounts/domain';
import { RecaptchaRequest } from '@accredible-frontend-v2/recaptcha';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface SignUpParams {
  user: {
    name: string;
    email: string;
    password: string;
  };
  domain: string;
}

const REGISTRATIONS_ENDPOINT = '/v1/credential-net/registrations';

@Injectable({
  providedIn: 'root',
})
export class SignUpApiService extends AccountsApiService {
  signUp(
    signUpParams: SignUpParams,
    recaptcha: string,
    v3Recaptcha: boolean,
  ): Observable<{ email: string; name: string }> {
    signUpParams[v3Recaptcha ? RecaptchaRequest.V3 : RecaptchaRequest.V2] = recaptcha;
    return this._post(REGISTRATIONS_ENDPOINT, signUpParams).pipe(
      map((res) => this._handleResponse(res, 'user')),
      catchError((res) => {
        // TODO(Fred): Refactor this to use this_handleError(res) instead when recaptcha is refactored to use a specific status key.
        throw res;
      }),
    );
  }

  resendEmail(email: string, domain: string): Observable<any> {
    return this._post(`${REGISTRATIONS_ENDPOINT}/resend_confirmation_email`, {
      email,
      domain,
    }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
